import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../helpers";
import _ from "lodash";
import { Table } from "./table";
import { toJS } from "mobx";
import { TableHeader } from "./survey-summary";
import { useTranslation } from "react-i18next";
import { useTableVisibility } from "./use-table-visibility";
import { AudioAnalyticsTable } from "./audioanalyticstable";

export const SurveysByAudio = observer((props) => {
    const { surveyResponseStore, userStore } = useStore();
    const { allSurveyResponsesSummary } = surveyResponseStore;
    const { t } = useTranslation("survey_management");
    const isVisible = useTableVisibility("surveys_by_audio");

    const data = useMemo(
        () => toJS(allSurveyResponsesSummary)?.["by_surveyor_audio"] || [],
        [allSurveyResponsesSummary]
    );

    const columns = useMemo(
        () => [
            {
                Header: t("name"),
                accessor: "surveyor_name",
                Footer: t("total"),
                Cell: (row) => {
                    return (
                        <div>
                            {row.row.original["surveyor_id"]} - {row.cell.value}
                        </div>
                    );
                },
            },
            {
                Header: t("has_audio"),
                accessor: "has audio",
                Footer: surveyResponseStore.get_total_surveys(data, "has audio"),
            },
            {
                Header: t("no_audio"),
                accessor: "no audio",
                Footer: surveyResponseStore.get_total_surveys(data, "no audio"),
            },
            {
                Header: t("total_surveys"),
                accessor: "total",
                Footer: surveyResponseStore.get_total_surveys(data, "total"),
            },
        ],
        [allSurveyResponsesSummary]
    );

    if (!isVisible) return null;
    if (!allSurveyResponsesSummary) return null;
    if (_.isEmpty(allSurveyResponsesSummary["by_surveyor_audio"])) return null;

    const row_click_handler = (x) => {
        surveyResponseStore.applyFilter("surveyor_id", x["surveyor_id"], `Audios By: ${x["surveyor_name"]}`);
    };

    return (
        <div className="w-100 flex flex-col md:w-0">
            <TableHeader title={t("interviews_highlights")} />
            <Table data={data} columns={columns} onRowClick={row_click_handler} />

            {/*<AudioAnalyticsTable data={data} pageSize={10} onRowClick={row_click_handler} />*/}
        </div>
    );
});
